import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=37d9c6ca&scoped=true&"
import script from "./Stores.vue?vue&type=script&lang=js&"
export * from "./Stores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9c6ca",
  null
  
)

export default component.exports